/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './patient-condition.reducer';

export const PatientCondition = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const patientConditionList = useAppSelector(state => state.patientCondition.entities);
  const loading = useAppSelector(state => state.patientCondition.loading);
  const totalItems = useAppSelector(state => state.patientCondition.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="patient-condition-heading" data-cy="PatientConditionHeading">
        <Translate contentKey="tinyMedicRestApp.patientCondition.home.title">Patient Conditions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.patientCondition.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/patient-condition/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.patientCondition.home.createLabel">Create new Patient Condition</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.patientCondition.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {patientConditionList && patientConditionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.startDate">Start Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startDate')} />
                </th>
                <th className="hand" onClick={sort('startObservations')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.startObservations">Start Observations</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('startObservations')} />
                </th>
                <th className="hand" onClick={sort('suspendedDate')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedDate">Suspended Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedDate')} />
                </th>
                <th className="hand" onClick={sort('suspendedObservations')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedObservations">Suspended Observations</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedObservations')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('clinicalStatus')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.clinicalStatus">Clinical Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('clinicalStatus')} />
                </th>
                <th className="hand" onClick={sort('verificationStatus')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.verificationStatus">Verification Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('verificationStatus')} />
                </th>
                <th className="hand" onClick={sort('conditionCategory')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.conditionCategory">Condition Category</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('conditionCategory')} />
                </th>
                <th className="hand" onClick={sort('conditionSeverity')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.conditionSeverity">Condition Severity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('conditionSeverity')} />
                </th>
                <th className="hand" onClick={sort('snomedBodySiteConceptId')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.snomedBodySiteConceptId">Snomed Body Site Concept Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('snomedBodySiteConceptId')} />
                </th>
                <th className="hand" onClick={sort('snomedBodySiteConceptText')}>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.snomedBodySiteConceptText">
                    Snomed Body Site Concept Text
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('snomedBodySiteConceptText')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.chronicCondition">Chronic Condition</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.suspendedBy">Suspended By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.reportedBy">Reported By</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientCondition.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {patientConditionList.map((patientCondition, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/patient-condition/${patientCondition.id}`} color="link" size="sm">
                      {patientCondition.id}
                    </Button>
                  </td>
                  <td>{patientCondition.active ? 'true' : 'false'}</td>
                  <td>{patientCondition.microSec}</td>
                  <td>{patientCondition.lastupdated}</td>
                  <td>{patientCondition.timestampentry}</td>
                  <td>{patientCondition.cursor}</td>
                  <td>{patientCondition.startDate}</td>
                  <td>{patientCondition.startObservations}</td>
                  <td>{patientCondition.suspendedDate}</td>
                  <td>{patientCondition.suspendedObservations}</td>
                  <td>{patientCondition.suspended ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ClinicalStatus.${patientCondition.clinicalStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.VerificationStatus.${patientCondition.verificationStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ConditionCategory.${patientCondition.conditionCategory}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ConditionSeverity.${patientCondition.conditionSeverity}`} />
                  </td>
                  <td>{patientCondition.snomedBodySiteConceptId}</td>
                  <td>{patientCondition.snomedBodySiteConceptText}</td>
                  <td>
                    {patientCondition.chronicCondition ? (
                      <Link to={`/chronic-condition/${patientCondition.chronicCondition.id}`}>{patientCondition.chronicCondition.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientCondition.suspendedBy ? (
                      <Link to={`/doctor/${patientCondition.suspendedBy.id}`}>{patientCondition.suspendedBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientCondition.reportedBy ? (
                      <Link to={`/doctor/${patientCondition.reportedBy.id}`}>{patientCondition.reportedBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientCondition.patient ? (
                      <Link to={`/gluco-user/${patientCondition.patient.id}`}>{patientCondition.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/patient-condition/${patientCondition.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/patient-condition/${patientCondition.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/patient-condition/${patientCondition.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.patientCondition.home.notFound">No Patient Conditions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={patientConditionList && patientConditionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PatientCondition;
